// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import { SubText, TitleH2 } from 'components/Common/Typography'
import Captcha from 'components/captcha'
import Router, { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import * as yup from 'yup'
import Image from 'next/image'
import Button from 'components/Button'

type FormValues = {
  yourName: string
  yourEmail: string
  phoneInput: string
  skypeID: string
  projectRequirements: string
}
interface CaptchaDetails {
  firstValue?: number
  secondValue?: number
  ans?: number
  isCaptchaMatched?: boolean
}
function ContactUsDarkSection() {
  const [captchaDetails, setCaptchaDetails] = useState<CaptchaDetails>({})

  const schema = yup.object().shape({
    yourName: yup.string().max(80).trim().required('Your Name is required'),
    yourEmail: yup
      .string()
      .email('Invalid email format')
      .max(255)
      .required('Your Email is required'),
    projectRequirements: yup
      .string()
      .trim()
      .required('Your Project Requirements is required'),
    // isCaptchaVerify: yup.boolean().required('Please Verify Captcha'),
    // solution: yup
    //   .string()
    //   .required('Captcha is required')
    //   .test('solution', 'Incorrect solution to math sum', (value: string) => {
    //     const solution = parseInt(value, 10)
    //     return solution === captchaDetails.ans
    //   }),
    phoneInput: yup
      .string()
      .test('isValidPhoneNumber', 'Invalid phone number', (value) =>
        value ? isValidPhoneNumber(value) : true
      ),
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
  })

  const [SuccessMesg, setSuccessMesg] = useState('')
  const [ErrorMesg, setErrorMesg] = useState('')
  const [Loading, setLoading] = useState(false)
  const router = useRouter()

  const PageUrl = router.query.path
    ? router.query.path
    : router.pathname.split('/')[1]
  const [phoneCountryCode, setPhoneCountryCode] = useState()
  const [formCountryName, setFromCountryName] = useState()

  const onSubmit: SubmitHandler<FormValues> = async (dataFetch) => {
    setLoading(true)
    setSuccessMesg('')
    setErrorMesg('')

    const newComment = {
      name: dataFetch.yourName,
      email: dataFetch.yourEmail,
      skypeId: dataFetch.skypeID,
      contactNumber: dataFetch.phoneInput,
      pro_requirements: dataFetch.projectRequirements,
      pageName: PageUrl,
      countryName: formCountryName,
    }

    try {
      const result = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}/api/user/contactUs/sendInquiry`,
        newComment,
        {
          headers: {
            web_id: 'webcluesinfotech',
          },
        }
      )

      if (result.data.code === 200) {
        setLoading(false)
        setSuccessMesg('Thank you for your message. It has been sent.')
        setTimeout(() => {
          Router.push('/thank-you')
        }, 100)
      } else {
        setLoading(false)
        const objres = {
          result: 'message',
        }
        setErrorMesg(objres.result)
      }
    } catch (error) {
      setLoading(false)
      setErrorMesg('Please try again after sometime')
    }
  }

  const fetchIpLocation = () => {
    ;(async () => {
      await axios.get(`https://ipapi.co/json/`).then((response) => {
        setPhoneCountryCode(response.data.country_code)
        setFromCountryName(response.data.country_name)
      })
    })()
  }

  useEffect(() => {
    fetchIpLocation()
  }, [])

  return (
    <section className="contactus_section_Dark">
      <Container fluid>
        <Row className="justify-content-start">
          <Col xl={12}>
            <TitleH2 className="title_md_white" text="Get in Touch" />

            <SubText
              className="mb-3 mt-3 text_para_large text-white"
              text="Take the First Step Towards a Successful Journey"
            />
            <p className="text-light text_para">
              WebClues is ready to become your partner and looks forward to a
              productive collaboration. We merge your vision with our ideas and
              technical acumen to build solutions that carve your success.
            </p>

            <div className="mt-4">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex" />
                <Row>
                  <Col xl={6} className="mb-2">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Your Name *"
                        className="bg-transparent"
                        {...register('yourName')}
                      />
                      <p className="alert-error">
                        {errors.yourName && (
                          <span>{errors.yourName.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={6} className="mb-2">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Your Email *"
                        className="bg-transparent"
                        {...register('yourEmail')}
                      />
                      <p className="alert-error">
                        {errors.yourEmail && (
                          <span>{errors.yourEmail.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={6} className="mb-2">
                    <Form.Group className="mb-3  bg-transparent">
                      <Controller
                        name="phoneInput"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            value={value}
                            onChange={(e: any) => onChange(e)}
                            defaultCountry={phoneCountryCode}
                            id="phoneInput"
                            className="form-control d-flex border-disable bg-transparent"
                            placeholder="Contact Number"
                          />
                        )}
                      />
                      <p className="alert-error">
                        {errors.phoneInput && (
                          <span>{errors.phoneInput.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={6} className="mb-2">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Skype ID"
                        className="bg-transparent"
                        {...register('skypeID')}
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mb-2 pt-3">
                    <Form.Control
                      as="textarea"
                      className="py-0 border-disable bg-transparent"
                      placeholder="Project Requirements *"
                      {...register('projectRequirements')}
                      rows={4}
                    />
                    <p className="alert-error">
                      {errors.projectRequirements && (
                        <span>{errors.projectRequirements.message}</span>
                      )}
                    </p>
                  </Col>
                  {/* <Col xl={12} className="mt-1">
                    <Form.Group className="pb-1 d-none1">
                      <Captcha onChange={(val) => setCaptchaDetails(val)}>
                        <Form.Control
                          type="text"
                          placeholder="Captcha code"
                          className="bg-transparent"
                          {...register('solution')}
                        />
                      </Captcha>
                      <p className="alert-error">
                        {errors.solution && (
                          <span>{errors.solution.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col> */}

                  <Col xl={12} className="mt-2">
                    <Form.Group className="pb-4" controlId="formBasicCheckbox">
                      <div className="d-flex">
                        <span className="me-2">
                          <Image
                            src="/assets/images/secure-icon.svg"
                            width={20}
                            height={20}
                            alt="secure-icon"
                          />
                        </span>
                        <span className="form-check-label text-light secure_text">
                          We respect your privacy and do not tolerate spam and
                          will never sell rent lease or give away your
                          information (name, address, email, etc) to any third
                          party. Nor will we send you unsolicited email
                        </span>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mt-4">
                    {Loading && (
                      <Button className="">
                       Send Request
                      </Button>
                    )}
                    {!Loading && (
                      <Button className="" type="submit">
                        Send Request
                      </Button>
                    )}
                    {Loading && (
                      <Spinner
                        className="ms-3"
                        animation="border"
                        variant="light"
                        role="status"
                        size="sm"
                      />
                    )}
                  </Col>
                  <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-successfully">
                    {SuccessMesg}
                  </p>
                  <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-error">
                    {ErrorMesg}
                  </p>
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default ContactUsDarkSection
